/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsPlatformBranchUpdateInput } from "../../entities/models/PlatformBranchUpdateInput";
import { z } from "zod/v4";

export const modelsPlatformBranchUpdateInputSchema = z.object({
    "address": z.optional(z.string()),
"name": z.optional(z.string()),
"phone": z.optional(z.string()),
"status": z.optional(z.enum(["active", "suspended"])),
"timezone": z.optional(z.string())
    }) as unknown as z.ZodType<ModelsPlatformBranchUpdateInput>